import { render, staticRenderFns } from "./LicenseInformationCard.vue?vue&type=template&id=f4b5d66e"
import script from "./LicenseInformationCard.vue?vue&type=script&lang=ts"
export * from "./LicenseInformationCard.vue?vue&type=script&lang=ts"
import style0 from "./LicenseInformationCard.vue?vue&type=style&index=0&id=f4b5d66e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./LicenseInformationCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports